import { Timestamp } from "firebase/firestore/lite";

export const convertTimestamp = (timestamp) => {
  if (!timestamp) return null;
  return new Date(timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000);
};
